<template>
  <div>
    <h1>Reporting des tickets</h1>
   
  </div>
</template>

<script>
  import { getBoards } from "@/utils/trello"

  export default {
    name: "ReportingTickets",
    data() {
      return {
        
      }
    },
    mounted() {
      this.fetchData();
    },
    methods: {
      fetchData() {
        getBoards.then((r) => {
          console.log(r);
        })
      },
     
    },
    computed: {
      
      
    }
  }
</script>

<style scoped>

</style>

<style>

  .hidden {
    opacity: 0;
    pointer-events: none;
  }


  .card-table {
    max-width: 100%;
    overflow-x: scroll;
  }

    .card-table table,
    .card-table thead,
    .card-table thead th,
    .card-table th,
    .card-table td {
      border: none !important;
    }

    .card-table thead {
      border-top: 1px solid #CCC !important;
      border-bottom: 1px solid #CCC !important;
    }

      .card-table thead th {
        background: white;
        text-align: center;
      }

    .card-table td {
      /*max-width: 200px;*/
    }

      .card-table td a {
        color: black;
        text-decoration: none;
      }
</style>



// WEBPACK FOOTER //
// src/pages/GestionProjet/ReportingTickets.vue